/* SVICLOUDnet — order tracking page.
   Same JSON contract as the Gadgeticloud page (7 states); bilingual UI, Chinese first
   per site convention. */
(function () {
  'use strict';
  var root = document.querySelector('[data-svi-track]');
  if (!root) return;

  var WEBHOOK = root.getAttribute('data-webhook-url');
  var SITEKEY = root.getAttribute('data-turnstile-sitekey');
  var form = root.querySelector('#svi-form');
  var out = root.querySelector('#svi-result');
  var btn = root.querySelector('#svi-submit');
  var tsHost = root.querySelector('#svi-turnstile');
  var tsWidget = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return String(iso);
    return d.toLocaleString(undefined, {
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  }

  /* ── Turnstile ──────────────────────────────────────────────────────────
     Hardened 2026-09-28 after a buyer-side "keeps spinning" report (Cloudflare analytics:
     24 challenges issued / 1 solved in 15 min for one visitor). Turnstile's defaults retry
     every 8s with no feedback, so a stuck widget looked dead. Now: 2.5s retries, auto refresh
     on expiry/timeout, token taken from the success callback, and a 15s watchdog that offers
     a restart and shows Turnstile's error code (so a report can be diagnosed). */
  var tsToken = '', tsErrors = 0, tsCode = '', tsWatch = null;
  var tsNote = document.createElement('div');
  tsNote.className = 'svi-ts-note'; tsNote.setAttribute('role', 'status'); tsNote.hidden = true;
  tsHost.parentNode.insertBefore(tsNote, tsHost.nextSibling);

  function tsStatus(html) { tsNote.innerHTML = html || ''; tsNote.hidden = !html; }
  function tsExplain() {
    var restart = '<button type="button" class="svi-ts-note__btn" data-ts-restart>重新驗證 Restart verification</button>';
    var code = tsCode;
    tsStatus(tsErrors ? ('驗證未能完成 Verification could not complete' + (code ? ' (code ' + esc(code) + ')' : '') + '. ' + restart + '<br><span>如持續失敗，請暫停 VPN 或廣告攔截器，或改用其他瀏覽器。If it keeps failing, pause your VPN or ad-blocker, or try another browser.</span>') : ('驗證時間較平常長。Verification is taking longer than usual. ' + restart + '<br><span>如持續轉動，請暫停 VPN 或廣告攔截器，或改用其他瀏覽器。If it keeps spinning, pause your VPN or ad-blocker, or try another browser.</span>'));
  }
  function tsArm() {
    clearTimeout(tsWatch);
    tsWatch = setTimeout(function () { if (!tsToken) tsExplain(); }, 15000);
  }
  function tsRestart() {
    tsToken = ''; tsErrors = 0; tsCode = ''; tsStatus('');
    if (window.turnstile && tsWidget !== null) { try { window.turnstile.reset(tsWidget); } catch (e) {} }
    tsArm();
  }
  tsNote.addEventListener('click', function (e) {
    if (e.target && e.target.hasAttribute('data-ts-restart')) tsRestart();
  });

  /* Turnstile is loaded lazily; the callback name is global by necessity. */
  window.sviTurnstileReady = function () {
    if (!SITEKEY || !window.turnstile || tsWidget !== null) return;
    tsWidget = window.turnstile.render(tsHost, {
      sitekey: SITEKEY, theme: 'light',
      retry: 'auto', 'retry-interval': 2500,
      'refresh-expired': 'auto', 'refresh-timeout': 'auto',
      callback: function (t) { tsToken = t || ''; tsErrors = 0; tsCode = ''; clearTimeout(tsWatch); tsStatus(''); },
      'expired-callback': function () { tsToken = ''; tsArm(); },
      'timeout-callback': function () { tsToken = ''; tsArm(); },
      /* A checkbox is waiting for the buyer: that is not "stuck", so pause the watchdog. */
      'before-interactive-callback': function () { clearTimeout(tsWatch); tsStatus(''); },
      'after-interactive-callback': function () { tsArm(); },
      'error-callback': function (code) {
        tsToken = ''; tsErrors++; tsCode = String(code || '');
        if (window.console) console.warn('[turnstile] error', tsCode);
        if (tsErrors >= 3) tsExplain();
        /* returning nothing keeps Turnstile's own retry loop running */
      }
    });
    tsArm();
  };
  (function loadTurnstile() {
    if (!SITEKEY) return;
    if (window.turnstile) { window.sviTurnstileReady(); return; }
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=sviTurnstileReady&render=explicit';
    s.async = true; s.defer = true;
    document.head.appendChild(s);
  })();

  var STATE_PILL = {
    delivered:   ['svi-pill--ok',  '已送達 Delivered'],
    in_transit:  ['svi-pill--live', '運送中 In transit'],
    exception:   ['svi-pill--stop', '需要跟進 Action needed'],
    awaiting_dispatch: ['svi-pill--warn', '準備發貨 Preparing']
  };

  function progressPct(state, cps) {
    if (state === 'delivered') return 100;
    if (state === 'awaiting_dispatch') return 8;
    if (!cps || !cps.length) return 20;
    return Math.min(85, 25 + cps.length * 12);
  }

  function renderSkeleton() {
    out.innerHTML = '<div class="svi-skel"><div style="width:45%"></div>' +
      '<div style="width:80%"></div><div style="width:65%"></div><div style="width:72%"></div></div>';
  }

  function note(kind, zh, en, extra) {
    return '<div class="svi-note ' + (kind ? 'svi-note--' + kind : '') + '">' +
      '<h3>' + zh + '</h3><p class="en">' + en + '</p>' + (extra || '') + '</div>';
  }

  function renderError(state) {
    var help = '<p>需要協助？請透過 <a href="/pages/contact-1">聯絡我們</a> 或 WhatsApp 查詢。</p>' +
               '<p class="en">Need help? <a href="/pages/contact-1">Contact us</a> and we will look it up for you.</p>';
    if (state === 'not_found') {
      out.innerHTML = note('warn', '找不到相符的訂單',
        'We could not find an order matching those details.',
        '<p>請確認訂單編號與確認電郵上的完全相同，以及電郵地址正確。</p>' +
        '<p class="en">Check the order number exactly matches your confirmation email, and that the email is the one used at checkout.</p>' + help);
    } else if (state === 'invalid_input') {
      out.innerHTML = note('warn', '請檢查輸入內容',
        'Please check what you entered.',
        '<p>訂單編號及電郵地址均為必填，並請完成驗證。</p>' +
        '<p class="en">Order number and email are both required, and the verification must complete.</p>');
    } else {
      out.innerHTML = note('stop', '暫時無法查詢',
        'Tracking is temporarily unavailable.',
        '<p>物流查詢服務暫時無法連線，請稍後再試。</p>' +
        '<p class="en">The tracking service did not respond. Please try again shortly.</p>' + help);
    }
  }

  function renderAwaiting(res) {
    var o = res.order || {};
    out.innerHTML =
      '<div class="svi-card"><div class="svi-card__head">' +
        '<div><div class="svi-card__order">' + esc(o.name || '') + '</div>' +
        '<div class="svi-card__meta">' + fmtDate(o.created_at) + '</div></div>' +
        '<span class="svi-pill svi-pill--warn">準備發貨 Preparing</span>' +
      '</div><div class="svi-card__body">' + itemsHtml(o) +
        '<div class="svi-bar"><div class="svi-bar__fill" style="width:8%"></div></div>' +
      '</div></div>' +
      note('', '訂單已確認，正在備貨',
        'Your order is confirmed and being prepared.',
        '<p>電視盒子一般以快遞寄出，3–6 個工作天送達，並提供追蹤號碼。發貨後你會收到電郵通知，之後即可在此查詢。</p>' +
        '<p class="en">TV boxes ship by tracked express, typically 3–6 working days. You will get an email with the tracking number once it is dispatched.</p>');
  }

  function itemsHtml(o) {
    var li = (o.line_items || []).map(function (i) {
      return '<li>' + esc(i.title) + ' × ' + esc(i.quantity) + '</li>';
    }).join('');
    return li ? '<ul class="svi-items">' + li + '</ul>' : '';
  }

  function shipmentHtml(s, state) {
    var cps = (s.checkpoints || []).slice().sort(function (a, b) {
      return new Date(b.datetime || 0) - new Date(a.datetime || 0);
    });
    var tl = cps.map(function (c, i) {
      var cls = i === 0 ? 'is-latest' : 'is-done';
      return '<li class="' + cls + '">' +
        '<div class="svi-tl__time">' + fmtDate(c.datetime) + '</div>' +
        '<div class="svi-tl__msg">' + esc(c.message || '') + '</div>' +
        (c.location ? '<div class="svi-tl__loc">' + esc(c.location) + '</div>' : '') +
        '</li>';
    }).join('');

    var eta = '';
    if (state === 'delivered' && s.shipment_delivery_date) {
      eta = '<div class="svi-ship__eta">送達時間 Delivered: ' + fmtDate(s.shipment_delivery_date) + '</div>';
    } else if (s.expected_delivery) {
      eta = '<div class="svi-ship__eta">預計送達 Estimated: ' + fmtDate(s.expected_delivery) + '</div>';
    }

    return '<div class="svi-ship">' +
      '<div class="svi-ship__head"><span class="svi-ship__carrier">' + esc(s.carrier || 'Carrier') + '</span>' +
      (s.tracking_number ? '<span class="svi-ship__num">' + esc(s.tracking_number) + '</span>' : '') +
      '</div>' + eta +
      (s.carrier_message ? '<div class="svi-ship__msg">' + esc(s.carrier_message) + '</div>' : '') +
      '<div class="svi-bar"><div class="svi-bar__fill" style="width:' + progressPct(state, cps) + '%"></div></div>' +
      (tl ? '<ul class="svi-tl">' + tl + '</ul>' : '') +
      (s.tracking_url ? '<a class="svi-ship__link" href="' + esc(s.tracking_url) +
        '" target="_blank" rel="noopener">在物流商網站查看 · View on carrier site →</a>' : '') +
      '</div>';
  }

  function renderTimeline(res) {
    var o = res.order || {};
    var pill = STATE_PILL[res.state] || STATE_PILL.in_transit;
    var ships = (res.shipments || []).map(function (s) { return shipmentHtml(s, res.state); }).join('');
    out.innerHTML =
      '<div class="svi-card"><div class="svi-card__head">' +
        '<div><div class="svi-card__order">' + esc(o.name || '') + '</div>' +
        '<div class="svi-card__meta">' + fmtDate(o.created_at) + '</div></div>' +
        '<span class="svi-pill ' + pill[0] + '">' + pill[1] + '</span>' +
      '</div><div class="svi-card__body">' + itemsHtml(o) + ships + '</div></div>' +
      (res.state === 'exception'
        ? note('warn', '此件需要跟進', 'This shipment needs attention.',
            '<p>請聯絡我們，我們會代你向物流商查詢。</p>' +
            '<p class="en"><a href="/pages/contact-1">Contact us</a> and we will chase the carrier for you.</p>')
        : '');
  }

  function render(res) {
    switch (res.state) {
      case 'in_transit':
      case 'delivered':
      case 'exception': return renderTimeline(res);
      case 'awaiting_dispatch': return renderAwaiting(res);
      default: return renderError(res.state);
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var typed = (form.querySelector('#svi-order').value || '').trim();
    /* The field shows a fixed "ST" affix and takes only the remainder, so the full order
       number format is never printed on the page. A buyer who pastes their WHOLE order
       number would otherwise submit a doubled prefix, so strip a leading ST first. */
    var order = typed ? ('ST' + typed.replace(/^\s*ST/i, '')).toUpperCase() : '';
    var email = (form.querySelector('#svi-email').value || '').trim();
    if (!order || !email) { renderError('invalid_input'); return; }

    var token = '';
    if (SITEKEY) {
      token = tsToken || (window.turnstile && tsWidget !== null ? (window.turnstile.getResponse(tsWidget) || '') : '');
      if (!token) {
        out.innerHTML = note('warn', '請先完成驗證', 'Please complete the verification first.', '');
        tsExplain();
        return;
      }
    }

    btn.disabled = true;
    renderSkeleton();

    fetch(WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_number: order, email: email, turnstile_token: token })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { render(res || { state: 'network_error' }); })
      .catch(function () { renderError('network_error'); })
      .finally(function () {
        btn.disabled = false;
        /* A Turnstile token is single-use — without a reset the second lookup always fails. */
        tsRestart();
      });
  });
})();
